'use client';
import OpportunitiesCard from '@/components/EntryOpportunities/OpportunitiesCard';
import { ArrowUpRightIcon } from '@heroicons/react/16/solid';
import ModalForm from '../Modal/Modal';
import { ReactNode, useState } from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

export interface EntryOpportunitiesBlockProps {
  id?: string;
  title: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  title_2?: ReactNode | SerializedEditorState;
  cardList: Array<{
    title: ReactNode | SerializedEditorState;
    subtitle?: ReactNode | SerializedEditorState;
    listItems?:
      | Array<string>
      | Array<{
          item: ReactNode | SerializedEditorState;
        }>;
  }>;
  buttonText: string;
  color?: 'violet' | 'green' | 'blue';
}

export default function EntryOpportunitiesBlock({
  title,
  subtitle,
  cardList,
  id,
  color = 'green',
  title_2,
  buttonText,
}: EntryOpportunitiesBlockProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);
  const backgroundColorClass =
    {
      green: 'custom-gradient-green',
      blue: 'custom-gradient-blue',
      violet: 'custom-gradient-violet',
    }[color] || 'custom-gradient-green';
  return (
    <>
      <div
        id={id}
        data-meta="EntryOpportunitiesBlock"
        className={`container mx-auto px-4 sm:px-6 lg:px-8 my-6 flex flex-col justify-center rounded-3xl`}
      >
        <CustomRichText
          data={title}
          tag="h2"
          className="text-4xl font-bold tracking-tight text-center text-white sm:text-6xl mx-12 mt-14"
        />

        {subtitle && (
          <CustomRichText
            data={subtitle}
            tag="div"
            className="mt-4 text-xl leading-8 text-white text-center"
          />
        )}
        {title_2 && (
          <CustomRichText
            data={title_2}
            tag="div"
            className="mt-4 text-2xl font-bold leading-8 text-white text-center"
          />
        )}
        <div className="grid grid-cols-1 gap-2 lg:grid-cols-2 lg:grid-rows-3 lg:gap-4 px-6 py-14 lg:px-8">
          {cardList.map((item, index) => (
            <OpportunitiesCard
              key={index}
              title={item.title}
              subtitle={item.subtitle}
              listItems={item.listItems}
              index={index}
            />
          ))}
          <div className="flex items-center justify-center">
            <button
              onClick={openForm}
              className={`pl-8 pr-1 py-2 text-md h-fit font-bold text-white uppercase rounded-full  ring-${color}-500 ring-1 flex gap-2 items-center leading-8`}
            >
              <span className="max-sm:text-sm">{buttonText}</span>
              <div className={`rounded-full ${backgroundColorClass} p-2`}>
                <ArrowUpRightIcon className="text-white h-4 w-4" />
              </div>
            </button>
          </div>
        </div>
      </div>
      {isFormOpen && (
        <ModalForm closeForm={closeForm} btnMeta={{ tag: 'університет' }} color={color} />
      )}
    </>
  );
}
